const removeFirstItemFromArray = (src, element) => {
  const index = src.indexOf(element);
  if (index === -1) return src;
  return [...src.slice(0, index), ...src.slice(index + 1)];
};

export default removeFirstItemFromArray;
